<template>
  <div
    class="dossier-providers"
    v-show="
      mode == 'view'
        ? formData.is_applicable_answer == 'sim'
          ? true
          : false
        : true
    "
  >
    <!-- Wrapper próprio — mesmo padrão visual do DossierOutsourcing -->
    <div class="dossier-providers__wrapper">
      <!-- ─── Cabeçalho colapsável ─── -->
      <div class="dossier-providers__header" @click="toggleCollapse">
        <div class="dossier-providers__header-left">
          <span class="dossier-providers__state-icon" :class="headerStateClass">
            <i :class="headerStateIcon"></i>
          </span>
          <div>
            <h3 class="dossier-providers__title">
              Prestadores de Serviços de Saúde
            </h3>
            <span
              v-if="isCollapsed && providerSummary"
              class="dossier-providers__subtitle"
            >
              {{ providerSummary }}
            </span>
          </div>
        </div>
        <button
          class="dossier-providers__toggle"
          type="button"
          :aria-expanded="!isCollapsed"
        >
          <i
            class="fas"
            :class="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
          ></i>
        </button>
      </div>

      <!-- ─── Corpo ─── -->
      <div v-show="!isCollapsed" class="dossier-providers__body">
        <!-- Texto explicativo (modo edição) -->
        <div v-if="!isViewMode" class="dossier-providers__explainer">
          <p>
            Registre os profissionais de saúde que prestam serviços à ILPI por
            meio de contrato (não são CLT). Ex: médicos, nutricionistas,
            fisioterapeutas, psicólogos, fonoaudiólogos.<br />
            Profissionais CLT devem ser registrados no módulo
            <strong>RH – Colaboradores CLT</strong>.
          </p>
        </div>

        <!-- ── Pergunta condicional ── -->
        <div class="dossier-conditional__question">
          <label class="dossier-conditional__question-label">
            <i class="fas fa-question-circle mr-1"></i>
            A instituição possui prestadores de serviços de saúde por contrato?
          </label>
          <div class="dossier-conditional__options">
            <label class="dossier-conditional__option">
              <input
                type="radio"
                value="sim"
                v-model="formData.is_applicable_answer"
                :disabled="isViewMode"
                class="dossier-conditional__radio"
              />
              <span>Sim</span>
            </label>
            <label class="dossier-conditional__option">
              <input
                type="radio"
                value="nao"
                v-model="formData.is_applicable_answer"
                :disabled="isViewMode"
                class="dossier-conditional__radio"
              />
              <span
                >Não — todos os profissionais de saúde são CLT ou não há
                prestadores</span
              >
            </label>
          </div>
          <div
            v-if="formData.is_applicable_answer === 'nao'"
            class="dossier-conditional__na-message"
          >
            <i class="fas fa-info-circle mr-1"></i>
            Nenhum contrato de prestação de serviços precisa ser registrado.
            Este módulo não gera pendência para a instituição.
          </div>
        </div>

        <!-- ── Lista de prestadores (quando aplicável) ── -->
        <template>
          <!-- Lista existente -->
          <div
            v-for="(provider, index) in formData.providers"
            :key="provider._uid"
            class="dossier-providers__item"
          >
            <!-- Cabeçalho do item -->
            <div class="dossier-providers__item-header">
              <span class="dossier-providers__item-number">{{
                index + 1
              }}</span>
              <span class="dossier-providers__item-name">
                {{
                  provider.name || provider.cpf || "Prestador sem identificação"
                }}
              </span>
              <span
                v-if="provider.profession"
                class="dossier-providers__item-profession"
              >
                {{ provider.profession }}
              </span>
              <v-btn
                v-if="!isViewMode"
                icon
                small
                class="dossier-providers__item-remove"
                @click="removeProvider(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </v-btn>
            </div>

            <!-- Formulário do prestador -->
            <div class="dossier-providers__item-body">
              <!-- ── Busca por CPF ── -->
              <div class="dossier-providers__cpf-row">
                <div
                  class="dossier-providers__field dossier-providers__field--cpf"
                >
                  <label
                    class="dossier-providers__label dossier-providers__label--required"
                    >CPF</label
                  >
                  <v-text-field
                    v-if="!isViewMode"
                    v-model="provider.cpf"
                    v-mask="'###.###.###-##'"
                    dense
                    outlined
                    hide-details="auto"
                    placeholder="000.000.000-00"
                    :disabled="provider._cpfLocked"
                    class="dossier-providers__input"
                    @blur="onCpfBlur(index)"
                  />
                  <span v-else class="dossier-providers__view-value">{{
                    provider.cpf || "—"
                  }}</span>
                </div>

                <div
                  v-if="!isViewMode"
                  class="dossier-providers__field dossier-providers__field--action"
                >
                  <label class="dossier-providers__label">&nbsp;</label>
                  <v-btn
                    v-if="!provider._cpfLocked"
                    small
                    class="btn-add"
                    :loading="provider._searchLoading"
                    :disabled="!isCpfComplete(provider.cpf)"
                    @click="searchByCpf(index)"
                  >
                    <i class="fas fa-search mr-1"></i>
                    Buscar
                  </v-btn>
                  <v-btn
                    v-else
                    small
                    class="btn-notcertified"
                    @click="unlockCpf(index)"
                  >
                    <i class="fas fa-exchange-alt mr-1"></i>
                    Trocar
                  </v-btn>
                </div>
              </div>

              <!-- Feedback de busca -->
              <div
                v-if="provider._searchError"
                class="dossier-providers__search-error"
              >
                <i class="fas fa-exclamation-circle mr-1"></i
                >{{ provider._searchError }}
              </div>
              <div
                v-if="provider._notFound"
                class="dossier-conditional__na-message"
                style="margin-bottom: 10px"
              >
                <i class="fas fa-info-circle mr-1"></i>
                Profissional não encontrado no sistema.
                <a class="dossier-providers__link" @click="fillManually(index)">
                  Preencher manualmente
                </a>
              </div>

              <!-- Dados do prestador -->
              <div
                v-if="provider._showFields"
                class="dossier-providers__fields-grid"
              >
                <!-- Auto-preenchido -->
                <div
                  v-if="provider._autoFilled && !isViewMode"
                  class="dossier-providers__auto-badge"
                >
                  <i class="fas fa-sync-alt mr-1"></i>
                  Dados preenchidos automaticamente do cadastro
                </div>

                <!-- Nome -->
                <div
                  class="dossier-providers__field dossier-providers__field--full"
                >
                  <label
                    class="dossier-providers__label dossier-providers__label--required"
                    >Nome completo</label
                  >
                  <v-text-field
                    v-if="!isViewMode && !provider._autoFilled"
                    v-model="provider.name"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="[rules.required]"
                    class="dossier-providers__input"
                  />
                  <span
                    v-else
                    class="dossier-providers__view-value dossier-providers__view-value--highlight"
                  >
                    {{ provider.name || "—" }}
                  </span>
                </div>

                <!-- Profissão -->
                <div class="dossier-providers__field">
                  <label class="dossier-providers__label">Profissão</label>
                  <v-text-field
                    v-if="!isViewMode && !provider._autoFilled"
                    v-model="provider.profession"
                    dense
                    outlined
                    hide-details
                    placeholder="Ex: Médico, Nutricionista"
                    class="dossier-providers__input"
                  />
                  <span v-else class="dossier-providers__view-value">{{
                    provider.profession || "—"
                  }}</span>
                </div>

                <!-- Conselho de classe -->
                <div class="dossier-providers__field">
                  <label class="dossier-providers__label"
                    >Conselho de classe</label
                  >
                  <v-text-field
                    v-if="!isViewMode && !provider._autoFilled"
                    v-model="provider.council"
                    dense
                    outlined
                    hide-details
                    placeholder="Ex: CRM-SP 12345"
                    class="dossier-providers__input"
                  />
                  <span v-else class="dossier-providers__view-value">{{
                    provider.council || "—"
                  }}</span>
                </div>

                <!-- Tipo de contrato -->
                <div class="dossier-providers__field">
                  <label class="dossier-providers__label"
                    >Tipo de contrato</label
                  >
                  <v-select
                    v-if="!isViewMode"
                    v-model="provider.contract_type"
                    :items="contractTypes"
                    dense
                    outlined
                    hide-details
                    placeholder="Selecione"
                    class="dossier-providers__input"
                  />
                  <span v-else class="dossier-providers__view-value">{{
                    provider.contract_type || "—"
                  }}</span>
                </div>

                <!-- Data de início do contrato -->
                <div class="dossier-providers__field">
                  <label class="dossier-providers__label"
                    >Início do contrato</label
                  >
                  <v-text-field
                    v-if="!isViewMode"
                    v-model="provider.contract_start"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="dossier-providers__input"
                  />
                  <span v-else class="dossier-providers__view-value">
                    <i class="fas fa-calendar-alt mr-1"></i>
                    {{ formatDateBR(provider.contract_start) }}
                  </span>
                </div>

                <!-- Data de fim do contrato (opcional) -->
                <div class="dossier-providers__field">
                  <label class="dossier-providers__label"
                    >Fim do contrato</label
                  >
                  <v-text-field
                    v-if="!isViewMode"
                    v-model="provider.contract_end"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="dossier-providers__input"
                  />
                  <span v-else class="dossier-providers__view-value">
                    <template v-if="provider.contract_end">
                      <i class="fas fa-calendar-alt mr-1"></i>
                      {{ formatDateBR(provider.contract_end) }}
                    </template>
                    <span v-else class="dossier-providers__view-empty"
                      >Indeterminado</span
                    >
                  </span>
                </div>

                <!-- Upload do contrato -->
                <div
                  class="dossier-providers__field dossier-providers__field--full"
                >
                  <label class="dossier-providers__label"
                    >Contrato assinado (PDF)</label
                  >

                  <!-- Arquivo já anexado -->
                  <div
                    v-if="provider.file_url"
                    class="dossier-providers__file-attached"
                  >
                    <i class="fas fa-file-pdf dossier-providers__file-icon"></i>
                    <span class="dossier-providers__file-name">
                      {{ provider.file_name || "Contrato anexado" }}
                    </span>
                    <a
                      :href="provider.file_url"
                      target="_blank"
                      class="dossier-providers__file-link"
                    >
                      <i class="fas fa-external-link-alt mr-1"></i>Ver
                    </a>
                    <v-btn
                      v-if="!isViewMode"
                      x-small
                      text
                      class="btn-notcertified ml-2"
                      @click="triggerUpload(index)"
                    >
                      <i class="fas fa-sync-alt mr-1"></i>Substituir
                    </v-btn>
                  </div>

                  <!-- Sem arquivo -->
                  <div v-else class="dossier-providers__file-pending">
                    <span class="dossier-providers__pending-text">
                      <i class="fas fa-exclamation-circle mr-1"></i>Contrato não
                      anexado
                    </span>
                    <v-btn
                      v-if="!isViewMode"
                      small
                      class="btn-add mt-1"
                      :loading="provider._uploadLoading"
                      @click="triggerUpload(index)"
                    >
                      <i class="fas fa-upload mr-1"></i>Anexar contrato
                    </v-btn>
                  </div>

                  <!-- Input file oculto por item -->
                  <input
                    v-if="!isViewMode"
                    :ref="`fileInput_${index}`"
                    type="file"
                    accept="application/pdf"
                    style="display: none"
                    @change="(e) => handleFileChange(e, index)"
                  />
                  <div
                    v-if="provider._uploadError"
                    class="dossier-providers__upload-error"
                  >
                    <i class="fas fa-times-circle mr-1"></i
                    >{{ provider._uploadError }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botão adicionar prestador -->
          <div
            v-if="!isViewMode && formData.is_applicable_answer === 'sim'"
            class="dossier-providers__add"
          >
            <v-btn small class="btn-add" @click="addProvider">
              <i class="fas fa-plus mr-1"></i>
              Adicionar prestador
            </v-btn>
          </div>

          <!-- Estado vazio -->
          <div
            v-if="
              formData.providers.length === 0 &&
              !isViewMode &&
              formData.is_applicable_answer === 'sim'
            "
            class="dossier-providers__empty"
          >
            <i class="fas fa-user-md mr-1"></i>
            Nenhum prestador cadastrado. Clique em "Adicionar prestador" para
            começar.
          </div>

          <!-- Botão salvar lista completa -->
          <div v-if="!isViewMode" class="dossier-providers__save">
            <v-btn class="btn-add" :loading="saveLoading" @click="saveAll">
              <i class="fas fa-save mr-1"></i>
              Salvar prestadores
            </v-btn>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

// Campos de UI que não vão para a API (prefixo _)
// São reinicializados ao carregar dados do backend
const UI_FIELDS = {
  _uid: null, // ID local para v-for key
  _cpfLocked: false,
  _autoFilled: false,
  _showFields: false,
  _notFound: false,
  _searchLoading: false,
  _searchError: "",
  _uploadLoading: false,
  _uploadError: "",
};

// Estrutura limpa de um prestador
const emptyProvider = () => ({
  ...UI_FIELDS,
  _uid: Date.now() + Math.random(),
  // Dados persistidos
  id: null, // ID do backend (null = novo)
  user_id: null,
  cpf: "",
  name: "",
  profession: "",
  council: "",
  contract_type: null,
  contract_start: null,
  contract_end: null,
  file_url: null,
  file_name: null,
});

// Injeta campos de UI em um objeto vindo da API
const hydrateProvider = (raw) => ({
  ...UI_FIELDS,
  _uid: raw.id || Date.now() + Math.random(),
  _cpfLocked: !!raw.cpf,
  _autoFilled: !!raw.user_id,
  _showFields: !!raw.cpf,
  ...raw,
});

export default {
  name: "DossierHealthProviders",

  props: {
    mode: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "view"].includes(v),
    },
    initialData: { type: Object, default: () => ({}) },
    startCollapsed: { type: Boolean, default: false },
  },

  data() {
    const d = this.initialData || {};
    return {
      isCollapsed: this.startCollapsed,
      saveLoading: false,

      contractTypes: [
        "Pessoa Física (PF)",
        "Pessoa Jurídica (PJ)",
        "MEI",
        "Cooperativa",
      ],

      formData: {
        is_applicable_answer: d.is_applicable_answer || null,
        providers: (d.providers || []).map(hydrateProvider),
      },

      rules: {
        required: (v) => !!v || "Campo obrigatório",
      },
    };
  },

  computed: {
    isViewMode() {
      return this.mode === "view";
    },

    // Resumo para o cabeçalho colapsado
    providerSummary() {
      const n = this.formData.providers.length;
      if (!n) return null;
      return `${n} prestador${n !== 1 ? "es" : ""} cadastrado${
        n !== 1 ? "s" : ""
      }`;
    },

    // Estado geral do header
    headerState() {
      if (this.formData.is_applicable_answer === "nao") return "na";
      if (!this.formData.is_applicable_answer) return "pending";
      if (this.formData.providers.length === 0) return "pending";
      return "ok";
    },

    headerStateClass() {
      const map = { ok: "--ok", pending: "--pending", na: "--na" };
      return `dossier-providers__state-icon${
        map[this.headerState] || "--pending"
      }`;
    },

    headerStateIcon() {
      const map = {
        ok: "fas fa-check-circle",
        pending: "far fa-circle",
        na: "fas fa-minus-circle",
      };
      return map[this.headerState] || "far fa-circle";
    },
  },

  watch: {
    initialData: {
      deep: true,
      handler(d) {
        this.formData.is_applicable_answer = d.is_applicable_answer || null;
        this.formData.providers = (d.providers || []).map(hydrateProvider);
      },
    },
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    // ── Gerenciamento da lista ─────────────────────────────────────────────

    addProvider() {
      this.formData.providers.push(emptyProvider());
    },

    removeProvider(index) {
      this.formData.providers.splice(index, 1);
    },

    // ── Busca por CPF ──────────────────────────────────────────────────────

    isCpfComplete(cpf) {
      return (cpf || "").replace(/\D/g, "").length === 11;
    },

    onCpfBlur(index) {
      const p = this.formData.providers[index];
      if (this.isCpfComplete(p.cpf) && !p._cpfLocked) {
        this.searchByCpf(index);
      }
    },

    async searchByCpf(index) {
      const p = this.formData.providers[index];
      const cpf = (p.cpf || "").replace(/\D/g, "");
      if (cpf.length !== 11) return;

      // Usa Vue.set para manter reatividade em campos _ do objeto
      this.$set(this.formData.providers[index], "_searchLoading", true);
      this.$set(this.formData.providers[index], "_searchError", "");
      this.$set(this.formData.providers[index], "_notFound", false);

      try {
        const response = await api.get("/rest-home/user/find-by-cpf", {
          params: { cpf },
        });
        const { error, user } = response.data;

        if (error || !user) {
          this.$set(this.formData.providers[index], "_notFound", true);
          this.$set(this.formData.providers[index], "_cpfLocked", true);
          this.$set(this.formData.providers[index], "_showFields", true);
          return;
        }

        this.fillProviderFromUser(index, user);
      } catch (err) {
        this.$set(
          this.formData.providers[index],
          "_searchError",
          "Erro ao buscar. Tente novamente."
        );
        console.error("DossierHealthProviders.searchByCpf:", err);
      } finally {
        this.$set(this.formData.providers[index], "_searchLoading", false);
      }
    },

    fillProviderFromUser(index, user) {
      const council = this.buildCouncilString(
        user.professional_class_council_value
      );
      const p = this.formData.providers[index];

      this.$set(this.formData.providers, index, {
        ...p,
        user_id: user.id,
        name: user.name || "",
        profession: user.office || "",
        council,
        _autoFilled: true,
        _cpfLocked: true,
        _showFields: true,
        _notFound: false,
        _searchLoading: false,
        _searchError: "",
      });
    },

    unlockCpf(index) {
      const p = this.formData.providers[index];
      this.$set(this.formData.providers, index, {
        ...p,
        cpf: "",
        user_id: null,
        name: "",
        profession: "",
        council: "",
        _cpfLocked: false,
        _autoFilled: false,
        _showFields: false,
        _notFound: false,
        _searchError: "",
      });
    },

    fillManually(index) {
      this.$set(this.formData.providers[index], "_notFound", false);
      this.$set(this.formData.providers[index], "_showFields", true);
      this.$set(this.formData.providers[index], "_autoFilled", false);
    },

    // ── Upload de contrato por item ────────────────────────────────────────

    triggerUpload(index) {
      const ref = this.$refs[`fileInput_${index}`];
      if (ref && ref[0]) ref[0].click();
      else if (ref) ref.click();
    },

    async handleFileChange(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== "application/pdf") {
        this.$set(
          this.formData.providers[index],
          "_uploadError",
          "Apenas PDFs são aceitos."
        );
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$set(
          this.formData.providers[index],
          "_uploadError",
          "Arquivo deve ter no máximo 20MB."
        );
        return;
      }

      this.$set(this.formData.providers[index], "_uploadError", "");
      this.$set(this.formData.providers[index], "_uploadLoading", true);

      try {
        const formData = new FormData();
        formData.append("file", file, file.name);

        const response = await api.post(
          "/rest-home/dossier/health-providers/upload",
          formData
        );
        const { error, file_url, file_name, message } = response.data;

        if (error) {
          this.$set(
            this.formData.providers[index],
            "_uploadError",
            "Erro ao enviar arquivo."
          );
        } else {
          this.$set(this.formData.providers[index], "file_url", file_url);
          this.$set(
            this.formData.providers[index],
            "file_name",
            file_name || file.name
          );
          toast(message || "Contrato anexado com sucesso", "success");
        }
      } catch (err) {
        this.$set(
          this.formData.providers[index],
          "_uploadError",
          "Erro ao enviar. Tente novamente."
        );
        console.error("DossierHealthProviders.upload:", err);
      } finally {
        this.$set(this.formData.providers[index], "_uploadLoading", false);
        event.target.value = "";
      }
    },

    // ── Salvar lista completa ──────────────────────────────────────────────

    async saveAll() {
      try {
        this.saveLoading = true;

        // Remove campos _ antes de enviar
        const payload = {
          is_applicable_answer: this.formData.is_applicable_answer,
          providers: this.formData.providers.map((p) => {
            const clean = {};
            Object.keys(p).forEach((k) => {
              if (!k.startsWith("_")) clean[k] = p[k];
            });
            return clean;
          }),
        };

        const response = await api.post(
          "/rest-home/dossier/health-providers",
          payload
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.$emit("error", { module: "health_providers", errors });
        } else {
          toast(message || "Prestadores salvos com sucesso", "success");
          this.$emit("saved", { module: "health_providers", data: payload });
        }
      } catch (err) {
        console.error("DossierHealthProviders.saveAll:", err);
      } finally {
        this.saveLoading = false;
      }
    },

    // ── Utilitários ────────────────────────────────────────────────────────

    buildCouncilString(value) {
      if (!value) return "";
      return value; // Mantém o valor composto — exibição somente leitura
    },

    formatDateBR(dateStr) {
      if (!dateStr) return "—";
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    },
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════════════════════════════
   DOSSIER PRESTADORES DE SAÚDE
   ═══════════════════════════════════════════════════════════════ */

/* ── Wrapper externo ─────────────────────────────────────────── */
.dossier-providers__wrapper {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
  transition: box-shadow 0.2s;
}

.dossier-providers__wrapper:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* ── Cabeçalho ───────────────────────────────────────────────── */
.dossier-providers__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8f8f7;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  user-select: none;
}

.dossier-providers__header:hover {
  background: #f0f0ef;
}

.dossier-providers__header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dossier-providers__title {
  font-size: 14px;
  font-weight: 600;
  color: #33495e;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.dossier-providers__subtitle {
  font-size: 12px;
  color: #888;
  display: block;
  margin-top: 2px;
}

/* ── Ícone de estado ─────────────────────────────────────────── */
.dossier-providers__state-icon {
  font-size: 15px;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}

.dossier-providers__state-icon--ok {
  color: #30915b;
}
.dossier-providers__state-icon--pending {
  color: #ccc;
}
.dossier-providers__state-icon--na {
  color: #bbb;
}

.dossier-providers__toggle {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #888;
  font-size: 13px;
}

.dossier-providers__toggle:hover {
  color: #1f5a76;
}

/* ── Corpo ───────────────────────────────────────────────────── */
.dossier-providers__body {
  padding: 16px;
}

/* ── Explicativo ─────────────────────────────────────────────── */
.dossier-providers__explainer {
  font-size: 13px;
  color: #555;
  background: #f8f8f7;
  border-left: 3px solid #1f5a76;
  border-radius: 0 4px 4px 0;
  padding: 10px 12px;
  margin-bottom: 14px;
  line-height: 1.6;
}

.dossier-providers__explainer p {
  margin: 0;
}

/* ── Item de prestador ───────────────────────────────────────── */
.dossier-providers__item {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: hidden;
}

.dossier-providers__item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f4f4f3;
  border-bottom: 1px solid #e8e8e8;
}

.dossier-providers__item-number {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1f5a76;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dossier-providers__item-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dossier-providers__item-profession {
  font-size: 11px;
  color: #888;
  flex-shrink: 0;
}

.dossier-providers__item-remove {
  color: #dc3545 !important;
  flex-shrink: 0;
}

.dossier-providers__item-body {
  padding: 12px;
}

/* ── CPF row ─────────────────────────────────────────────────── */
.dossier-providers__cpf-row {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.dossier-providers__field {
  display: flex;
  flex-direction: column;
}

.dossier-providers__field--cpf {
  flex: 0 0 200px;
}
.dossier-providers__field--action {
  flex: 0 0 auto;
}
.dossier-providers__field--full {
  flex: 0 0 100%;
}

/* ── Labels e inputs ─────────────────────────────────────────── */
.dossier-providers__label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}

.dossier-providers__label--required::after {
  content: " *";
  color: #dc3545;
}

.dossier-providers__input {
  font-size: 13px;
}

/* ── Grid de campos do prestador ─────────────────────────────── */
.dossier-providers__fields-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.dossier-providers__fields-grid .dossier-providers__field {
  flex: 1;
  min-width: 160px;
}

/* ── Badge automático ────────────────────────────────────────── */
.dossier-providers__auto-badge {
  flex: 0 0 100%;
  font-size: 11px;
  color: #1f5a76;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 1px solid #b8d9ec;
  margin-bottom: 4px;
}

/* ── Arquivo ─────────────────────────────────────────────────── */
.dossier-providers__file-attached {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #f4fff8;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
}

.dossier-providers__file-icon {
  font-size: 16px;
  color: #dc3545;
}

.dossier-providers__file-name {
  font-size: 12px;
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dossier-providers__file-link {
  font-size: 12px;
  color: #1f5a76;
  font-weight: 600;
  flex-shrink: 0;
}

.dossier-providers__file-pending {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dossier-providers__pending-text {
  font-size: 12px;
  color: #888;
  font-style: italic;
}

.dossier-providers__upload-error {
  font-size: 12px;
  color: #dc3545;
  font-weight: 600;
  margin-top: 4px;
}

/* ── Feedbacks ───────────────────────────────────────────────── */
.dossier-providers__search-error {
  font-size: 12px;
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 8px;
}

.dossier-providers__link {
  color: #1f5a76;
  font-weight: 600;
  cursor: pointer;
  margin-left: 4px;
  text-decoration: underline;
}

/* ── Valores visualização ────────────────────────────────────── */
.dossier-providers__view-value {
  font-size: 13px;
  color: #333;
  padding: 4px 0;
  display: block;
}

.dossier-providers__view-value--highlight {
  font-weight: 600;
  color: #1f5a76;
}

.dossier-providers__view-empty {
  font-size: 12px;
  color: #aaa;
}

/* ── Ações ───────────────────────────────────────────────────── */
.dossier-providers__add {
  margin-top: 8px;
}

.dossier-providers__save {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0ef;
}

/* ── Estado vazio ────────────────────────────────────────────── */
.dossier-providers__empty {
  font-size: 13px;
  color: #888;
  font-style: italic;
  padding: 16px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  text-align: center;
  margin-top: 8px;
}

/* ── Responsivo ──────────────────────────────────────────────── */
@media (max-width: 600px) {
  .dossier-providers__body {
    padding: 12px;
  }

  .dossier-providers__cpf-row {
    flex-direction: column;
  }
  .dossier-providers__field--cpf {
    flex: unset;
    width: 100%;
  }

  .dossier-providers__fields-grid .dossier-providers__field {
    flex: 0 0 100%;
  }
}
</style>